import { canParseJson } from "./commonHelper";

export function getSelectedPrincipal() {
  const principalString = localStorage.getItem("selectedPrincipal");
  if (canParseJson(principalString)) return JSON.parse(principalString);
  else return null;
}
